import React, { FC } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export enum ZoomControlSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}
interface ZoomControlProps {
  zoomLevel: number;
  onZoomChange: (value: number) => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  minZoom?: number;
  maxZoom?: number;
  size?: ZoomControlSize;
  bottomClass?: string;
}

const ZoomControl: FC<ZoomControlProps> = ({
  zoomLevel,
  onZoomChange,
  onZoomIn,
  onZoomOut,
  minZoom = 1,
  maxZoom = 8,
  size = ZoomControlSize.MEDIUM,
  bottomClass = "bottom-6",
}) => {
  const sizeClasses = {
    [ZoomControlSize.SMALL]: {
      container: "p-2",
      button: "w-6 h-6",
      icon: " p-1",
      slider: "h-28",
      handle: {
        left: "-15%",
        width: "28px",
        height: "0.30rem",
      },
    },
    [ZoomControlSize.MEDIUM]: {
      container: "p-4",
      button: "w-8 h-8",
      icon: "p-2",
      slider: "h-40",
      handle: {
        left: "-25%",
        width: "32px",
        height: "0.5rem",
      },
    },
    [ZoomControlSize.LARGE]: {
      container: "p-4",
      button: "w-10 h-10",
      icon: "p-3",
      slider: "h-50",
      handle: {
        left: "-25%",
        width: "32px",
        height: "0.5rem",
      },
    },
  }[size];
  return (
    <div
      className={`fixed bg-black backdrop--tinted right-6 flex flex-col items-center space-y-4 z-10 rounded-[60px] border-2 border-[#ffffff80] ${sizeClasses.container} ${bottomClass}`}
    >
      {/* Zoom In Button */}
      <button
        onClick={onZoomIn}
        className={`${sizeClasses.button} flex rounded-full bg-white ${zoomLevel === maxZoom ? "bg-opacity-10" : "bg-opacity-20"} hover:bg-opacity-30 transition`}
        aria-label="Zoom In"
      >
        <span
          className={`${sizeClasses.icon} d-icon d-add-solid justify-center items-center`}
        ></span>
      </button>

      {/* Vertical Zoom Range Slider */}
      <div className={`flex justify-center items-center ${sizeClasses.slider}`}>
        <Slider
          vertical
          min={minZoom}
          max={maxZoom}
          step={0.5}
          value={zoomLevel}
          onChange={(value) =>
            onZoomChange(Array.isArray(value) ? value[0] : value)
          }
          className={`flex ${sizeClasses.slider} transform origin-center`}
          styles={{
            track: {
              background: "white",
            },
            handle: {
              left: sizeClasses.handle.left,
              width: sizeClasses.handle.width,
              height: sizeClasses.handle.height,
              borderRadius: "0.2rem",
              backgroundColor: "white",
              opacity: 1,
              border: "2px solid white",
            },
          }}
          ariaLabelForHandle="Zoom Level"
        />
      </div>

      {/* Zoom Out Button */}
      <button
        onClick={onZoomOut}
        className={`${sizeClasses.button} flex rounded-full bg-white ${zoomLevel === minZoom ? "bg-opacity-10" : "bg-opacity-20"} hover:bg-opacity-30 transition`}
        aria-label="Zoom Out"
      >
        <span
          className={`${sizeClasses.icon} d-icon d-minus-solid justify-center items-center`}
        ></span>
      </button>
    </div>
  );
};

export default ZoomControl;
